<!-- www.quickepay / Contact
Edited with WebStorm
Created by maizerg on 2/19/18 at 3:22 PM
<!-->

<template>
    <div id="contact">
        <quick-site-bread-crumb title="Contacte-nos"/>
        <div class="contactArea secPdng padTopNone">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 animated">
                        <div class="contactTxt">
                            <p>
                                Pode sempre contactar-nos, serà sempre um imenso prazer ajuda-lo com qualquer que seja a duvida.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <form id="ajax-contact" action="#" class="contactForm" @submit.prevent="sendMessage()">
                            <div class="contactInput name-input">
                                <input id="name" required v-model="formData.name" name="name" type="text"
                                       placeholder="Seu nome*">
                            </div>
                            <div class="contactInput">
                                <input id="email" required v-model="formData.email" name="email" type="email"
                                       placeholder="O seu email*">
                            </div>
                            <div class="contactInput">
                                <input id="phoneNo" required v-model="formData.phone" name="phoneNo" type="number"
                                       placeholder="Telefone/Telemòvel*">
                            </div>
                            <div class="contactMsg">
                            <textarea id="contactMsg" required v-model="formData.msg" name="contactMsg"
                                      placeholder="Descreva a sua mensagem neste campo..."></textarea>
                            </div>
                            <div class="contactSubmit" v-show="!sending">
                                <input id="submit" name="submit" type="submit"
                                       value="Enviar mensagem">
                            </div>
                            <div id="form-messages" class="success" v-show="sending">
                                Enviado
                            </div>
                        </form>
                    </div>
                    <div class="col-md-6">
                        <div class="contactInfoCell">
                            <div class="singleInfo">
                                <div class="h4">Ou pode ligar-nos</div>
                                <div class="singleContactInfo"><span>Moçambique:</span>
                                    <a href="tel:+258 21 08 27 08">
                                        +258 21 08 27 08
                                        <!--{{ company.tel }}-->
                                    </a>
                                </div>
                            </div>
                            <div class="singleInfo">
                                <div class="h4">Talvez um Email?</div>
                                <div class="singleContactInfo"><span>Suporte de Empresas:</span> <a
                                        href="mailto:suporte-pessoal@quickepay.co.mz">suporte-empresas@quickepay.co.mz</a>
                                </div>
                                <div class="singleContactInfo"><span>Suporte de pessoais :</span> <a
                                        href="mailto:suporte-pessoal@quickepay.co.mz">suporte-pessoal@quickepay.co.mz</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuickSiteBreadCrumb from '../components/site/SiteBreadCrumb'
import Animate from '../assets/js/animation'

export default {
  components: {
    QuickSiteBreadCrumb
  },
  data () {
    return {
      sending: false,
      formData: {
        name: '',
        email: '',
        phone: '',
        msg: ''
      }
    }
  },
  methods: {
    sendMessage () {
      this.clearForm()
      this.sending = true
    },
    clearForm () {
      this.formData.name = ''
      this.formData.email = ''
      this.formData.phone = ''
      this.formData.msg = ''
    }
  },
  mounted () {
    Animate()
  }
}
</script>

<!--<script>
    import Company from '@/database/company.json'
    import Settings from '@/database/settings.json'

    export default {
        name: 'contact',
        data () {
            return {
                company: Company,
                settings: Settings
            }
        }
    }
</script>-->

<style>

</style>



// WEBPACK FOOTER //
// src/views/Contact.vue